/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S1_TitleInputs */

const en_fc_tut_s1_title = /** @type {(inputs: Fc_Tut_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install and open FilmCraft`)
};

/**
* | output |
* | --- |
* | "Install and open FilmCraft" |
*
* @param {Fc_Tut_S1_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s1_title = /** @type {((inputs?: Fc_Tut_S1_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S1_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s1_title(inputs)
});
export { fc_tut_s1_title as "fc.tut.s1.title" }